import "../../../../content/departments/media/seo.css";
import * as React from 'react';
export default {
  React
};